import _objectSpread from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
import DeliveryCost from "./DeliveryCost.vue";
import providerApiService from "../../services/api/ProviderApiService";
import MapHtml from "./Map.html";
import { isArray } from 'lodash';
export default {
  name: "Delivery",
  components: {
    DeliveryCost: DeliveryCost
  },
  data: function data() {
    return {
      deliveryPriceVisible: false,
      selectedZone: null,
      selectedFee: null,
      polygons: [],
      providerDeliveryFees: [],
      name: "Amir",
      greet: "Hello, ",
      htmlContent: MapHtml,
      mapInitialized: false // component: MapComponent,

    };
  },
  watch: {
    propertyAAndPropertyB: function propertyAAndPropertyB(newVal) {
      var _newVal$split = newVal.split('|'),
          _newVal$split2 = _slicedToArray(_newVal$split, 2),
          newPropertyA = _newVal$split2[0],
          newPropertyB = _newVal$split2[1];

      var polygons = JSON.parse(newPropertyA);
      var providerDeliveryFees = JSON.parse(newPropertyB);

      if (polygons && polygons.length > 0 && providerDeliveryFees && providerDeliveryFees.length > 0) {
        this.polygons = polygons.map(function (item) {
          var selected = item;
          providerDeliveryFees.forEach(function (element) {
            if (item.id === element.zone) {
              selected = _objectSpread(_objectSpread({}, item), {}, {
                feeId: element.id,
                fee: element.fee
              });
            }
          });
          return selected;
        });
        this.executeMapScript(this.polygons);
      }
    }
  },
  methods: {
    itemUpdated: function itemUpdated(deliveryFeeItem) {
      this.providerDeliveryFees.forEach(function (element) {
        if (element.id === deliveryFeeItem.id) {
          element.fee = deliveryFeeItem.fee;
        }
      });
      this.deliveryPriceVisible = false;
    },
    itemAdded: function itemAdded(deliveryFeeItem) {
      this.providerDeliveryFees.push(deliveryFeeItem);
      this.deliveryPriceVisible = false;
    },
    itemDeleted: function itemDeleted(deliveryFeeItem) {
      this.providerDeliveryFees = this.providerDeliveryFees.filter(function (element) {
        return element.id !== deliveryFeeItem.id;
      });
      this.deliveryPriceVisible = false;
    },
    polygonClicked: function polygonClicked(event) {
      var _this = this;

      var item = event.detail;
      this.selectedFee = null;
      this.providerDeliveryFees.forEach(function (element) {
        if (element.zone === item.id) {
          _this.selectedFee = element;
          return;
        }
      });
      this.selectedZone = item;
      this.deliveryPriceVisible = true;
    },
    getAllPolygons: function getAllPolygons() {
      var _this2 = this;

      providerApiService.getAllMapPolygons().then(function (result) {
        _this2.polygons = result.data;

        _this2.getProviderDeliveryFees();
      });
    },
    getProviderDeliveryFees: function getProviderDeliveryFees() {
      var _this3 = this;

      providerApiService.getProviderDeliveryFees(this.currentProvider.id).then(function (result) {
        if (isArray(result.data) && result.data.length > 0) {
          _this3.providerDeliveryFees = result.data;
        } else {
          _this3.executeMapScript(_this3.polygons);
        }
      });
    },
    getProviderDeliveryFee: function getProviderDeliveryFee(zoneId) {
      var item = this.providerDeliveryFees.find(function (element) {
        return element.zone === zoneId;
      });

      if (item) {
        if (+item.fee > 0) {
          return item.fee.toString().splitNumberFormat().numberFormat();
        }

        if (+item.fee === 0) {
          return "رایگان";
        }

        return null;
      }

      return null;
    },
    executeMapScript: function executeMapScript(polygonsCoordinates) {
      /**
       * Run map script for displaying polygons
       */
      if (!this.mapInitialized) {
        this.runScript(1, polygonsCoordinates);
        this.mapInitialized = true;
      }
    },
    executeLeafletScript: function executeLeafletScript() {
      /**
       * Run leaflet script
       */
      this.runScript(0);
    },
    runScript: function runScript(i, polygonsCoordinates) {
      var container = document.getElementById("neshanmap");
      var scriptsTags = container.getElementsByTagName("script");
      var newScriptTag = document.createElement("script");
      newScriptTag.async = true;
      newScriptTag.type = "text/javascript";

      if (polygonsCoordinates) {
        var text = "\n            var latlngs = ".concat(JSON.stringify(polygonsCoordinates), ";\n            latlngs.forEach(function (item, index) {\n              var polygon = L.polygon(item.coordinates, { color: item.feeId ? \"green\" : \"grey\" }).addTo(myMap);\n              polygon.on('click', function (e) {\n                window.polygonEvent = new CustomEvent(\"polygonClicked\", { 'detail': item });\n                window.dispatchEvent(window.polygonEvent);\n              });\n            })\n          ");
        newScriptTag.text = scriptsTags[i].text + "\n" + text;
      }

      if (scriptsTags[i].src) {
        newScriptTag.src = scriptsTags[i].src;
      }

      document.head.appendChild(newScriptTag);
    }
  },
  mounted: function mounted() {
    this.getAllPolygons();
    this.executeLeafletScript();
    window.addEventListener("polygonClicked", this.polygonClicked);
  },
  destroyed: function destroyed() {
    window.removeEventListener("polygonClicked", this.polygonClicked);
  },
  computed: _objectSpread({
    propertyAAndPropertyB: function propertyAAndPropertyB() {
      return "".concat(JSON.stringify(this.polygons), "|").concat(JSON.stringify(this.providerDeliveryFees));
    }
  }, mapGetters({
    currentProvider: "profile/currentProvider"
  }))
};